export const ru = {
    confirmation_title: 'Удалить ассистента',
    confirmation_description: 'Вы точно хотите удалить ассистента для данного пользователя?',
};
